import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite';
import { diContainer } from '../DIContainer';
class SqliteStorage {
    static instance;
    sqlite;
    db = null;
    DB_NAME = 'pos.db';
    TABLE_NAME = 'key_value_store';
    SECRET_KEY = 'P1O2S3!';
    initialized = false;
    constructor() {
        this.sqlite = new SQLiteConnection(CapacitorSQLite);
    }
    static getInstance() {
        if (!SqliteStorage.instance) {
            SqliteStorage.instance = new SqliteStorage();
        }
        return SqliteStorage.instance;
    }
    async initialize() {
        if (this.initialized)
            return;
        try {
            const encryptionResult = await this.sqlite.isInConfigEncryption();
            const isEncryption = encryptionResult.result || false;
            if (isEncryption) {
                const secretResult = await this.sqlite.isSecretStored();
                if (!secretResult.result) {
                    await this.sqlite.setEncryptionSecret(this.SECRET_KEY);
                }
            }
            const ret = await this.sqlite.checkConnectionsConsistency();
            const isConn = (await this.sqlite.isConnection(this.DB_NAME, false)).result;
            if (ret.result && isConn) {
                this.db = await this.sqlite.retrieveConnection(this.DB_NAME, false);
            }
            else {
                this.db = await this.sqlite.createConnection(this.DB_NAME, isEncryption, 'secret', 1, false);
            }
            await this.db.open();
            const query = `
                CREATE TABLE IF NOT EXISTS ${this.TABLE_NAME} (
                    key TEXT PRIMARY KEY,
                    value TEXT
                )
            `;
            await this.db.execute(query);
            this.initialized = true;
        }
        catch (error) {
            const errorReporter = diContainer.resolve('errorReporter');
            errorReporter.reportMessage('Error initializing SQLite: ' + error.message);
            console.error('Error initializing SQLite:', error);
            throw error;
        }
    }
    async getItem(key) {
        if (!this.db)
            await this.initialize();
        try {
            const query = `SELECT value FROM ${this.TABLE_NAME} WHERE key = ?`;
            const result = await this.db.query(query, [key]);
            if (result.values && result.values.length > 0) {
                return result.values[0].value;
            }
            return null;
        }
        catch (error) {
            const errorReporter = diContainer.resolve('errorReporter');
            errorReporter.reportMessage('Error getting item from SQLite: ' + error.message);
            console.error('Error getting item from SQLite:', error);
            return null;
        }
    }
    async setItem(key, value) {
        if (!this.db)
            await this.initialize();
        try {
            const query = `
                INSERT OR REPLACE INTO ${this.TABLE_NAME} (key, value)
                VALUES (?, ?)
            `;
            await this.db.run(query, [key, value]);
        }
        catch (error) {
            const errorReporter = diContainer.resolve('errorReporter');
            errorReporter.reportMessage('Error setting item in SQLite: ' + error.message);
            console.error('Error setting item in SQLite:', error);
        }
    }
    async deleteItem(key) {
        if (!this.db)
            await this.initialize();
        try {
            const query = `DELETE FROM ${this.TABLE_NAME} WHERE key = ?`;
            await this.db.run(query, [key]);
        }
        catch (error) {
            const errorReporter = diContainer.resolve('errorReporter');
            errorReporter.reportMessage('Error deleting item from SQLite: ' + error.message);
            console.error('Error deleting item from SQLite:', error);
        }
    }
}
export const sqliteStorage = new SqliteStorage();
//# sourceMappingURL=SqliteStorage.js.map